export default __webpack_public_path__ + "896ef4ffd864a7aeb3c761dd82f5d268.png";